import { render, staticRenderFns } from "./estatisticas-atendente.vue?vue&type=template&id=2573a437&scoped=true"
import script from "./estatisticas-atendente.vue?vue&type=script&lang=js"
export * from "./estatisticas-atendente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2573a437",
  null
  
)

export default component.exports